
import React from 'react';
import { Loader2 } from 'lucide-react';

export interface LoadingStateProps {
  message?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ message }) => {
  return (
    <div className="flex flex-col items-center justify-center space-y-2 py-8">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      {message && <p className="text-muted-foreground">{message}</p>}
    </div>
  );
};
